import { render, staticRenderFns } from "./competitionVideoList.vue?vue&type=template&id=6ef83610&scoped=true"
import script from "./competitionVideoList.vue?vue&type=script&lang=js"
export * from "./competitionVideoList.vue?vue&type=script&lang=js"
import style0 from "./competitionVideoList.vue?vue&type=style&index=0&id=6ef83610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef83610",
  null
  
)

export default component.exports